import { render, staticRenderFns } from "./orderCoupon.vue?vue&type=template&id=6869850b&scoped=true&"
import script from "./orderCoupon.vue?vue&type=script&lang=js&"
export * from "./orderCoupon.vue?vue&type=script&lang=js&"
import style0 from "./orderCoupon.vue?vue&type=style&index=0&id=6869850b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6869850b",
  null
  
)

export default component.exports